<div [formGroup]="filterForm" class="filter-grid">
  <!-- Kód skupiny šablon: -->
  <ui-autocomplete
    label="Kód skupiny šablon"
    placeholder="Začněte psát text..."
    [field]="null"
    [minSearchLength]="2"
    [maxLength]="15"
    [autoHighlight]="false"
    formControlName="kodSkupinySablon"
    (handleAction)="handleKodSkupinySablonSearch($event)"
    [options]="kodSkupinySablonResults()"
    [help]="tooltipKodSkupinySablon"
    data-cy="katalog-skupin-kod" />

  <!-- Název skupiny šablon -->
  <ui-input
    [maxLength]="1024"
    placeholder="Začněte psát text..."
    class="filter-grid-field"
    label="Název skupiny šablon"
    formControlName="nazevSkupinySablon"
    [help]="tooltipNazevSkupinySablon"
    data-cy="katalog-skupin-nazev" />

  <!-- Kód šablony -->
  <ui-autocomplete
    label="Kód šablony"
    placeholder="Začněte psát text..."
    [field]="null"
    [minSearchLength]="2"
    [maxLength]="15"
    [autoHighlight]="false"
    formControlName="kodSablony"
    (handleAction)="handleKodSablonySearch($event)"
    [options]="kodSablonyResults()"
    [help]="tooltipKodSablony"
    data-cy="katalog-skupin-kod-sablony" />

  <!-- Název šablony -->
  <ui-input
    [maxLength]="1024"
    placeholder="Začněte psát text..."
    class="filter-grid-field"
    label="Název šablony"
    formControlName="nazevSablony"
    [help]="tooltipNazevSablony"
    data-cy="katalog-skupin-nazev-sablony" />

  <!-- Vytvořeno -->
  <div>
    <ui-datepicker-range
      label="Vytvořeno"
      formControlName="datumVytvoreni"
      dataType="dateAsString"
      fromKey="dateFrom"
      toKey="dateTo"
      [help]="tooltipDatumVytvoreni"
      data-cy="katalog-skupin-datum-vytvoreni" />
  </div>

  <!-- Ukončeno -->
  <div>
    <ui-datepicker-range
      label="Ukončeno"
      formControlName="datumUkonceni"
      dataType="dateAsString"
      fromKey="dateFrom"
      toKey="dateTo"
      [help]="tooltipDatumUkonceni"
      data-cy="katalog-skupin-datum-ukonceni" />
  </div>

  <!-- Datum poslední změny -->
  <div>
    <ui-datepicker-range
      label="Datum poslední změny"
      formControlName="datumPosledniZmeny"
      dataType="dateAsString"
      fromKey="dateFrom"
      toKey="dateTo"
      [help]="tooltipDatumPosledniZmeny"
      data-cy="katalog-skupin-datum-zmeny" />
  </div>

  <!-- Status -->
  <ui-select
    label="Status"
    formControlName="status"
    class="filter-grid-field"
    placeholder="Vyberte status"
    [options]="statusOptions"
    optionLabel="label"
    optionValue="id"
    [help]="tooltipStatus"
    data-cy="katalog-skupin-status"></ui-select>
</div>
